import React from 'react';
import { Box, Grid, Skeleton, Stack } from '@mui/material';
import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';
import { radiusPx } from '../../../theme/tokens/radius';

const SECTION_COUNT = 4;
const FIELD_ROWS = [
  [6, 6],
  [6, 6],
  [12],
  [6, 6],
];

function FieldSkeleton({ tall = false }) {
  return (
    <Box>
      <Skeleton variant="text" width="38%" height={18} sx={{ mb: 0.75 }} />
      <Skeleton
        variant="rounded"
        height={tall ? 72 : 40}
        sx={{ borderRadius: radiusPx.md }}
      />
    </Box>
  );
}

function SectionSkeleton({ rows }) {
  const { semantic } = useFeatureTheme();
  const borders = semantic.borders ?? {};

  return (
    <Box
      sx={{
        borderRadius: radiusPx.lg,
        border: `1px solid ${borders.border}`,
        bgcolor: semantic.surfaces.surface,
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        sx={{
          px: 2.5,
          py: 2,
          borderBottom: `1px solid ${borders.border}`,
          bgcolor: semantic.surfaces.surfaceSubtle ?? semantic.surfaces.surface,
        }}
      >
        <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: radiusPx.md }} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="42%" height={22} />
          <Skeleton variant="text" width="72%" height={18} sx={{ mt: 0.5 }} />
        </Box>
      </Stack>
      <Box sx={{ px: 2.5, py: 2.25 }}>
        <Grid container spacing={3}>
          {rows.map((spans, rowIndex) =>
            spans.map((span, colIndex) => (
              <Grid item xs={12} md={span} key={`${rowIndex}-${colIndex}`}>
                <FieldSkeleton tall={span === 12 && rowIndex === 1} />
              </Grid>
            ))
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default function LicenseFormSkeleton() {
  return (
    <Stack spacing={3} aria-busy="true" aria-label="Loading license form">
      {Array.from({ length: SECTION_COUNT }, (_, index) => (
        <SectionSkeleton key={index} rows={[FIELD_ROWS[index] ?? [12]]} />
      ))}
    </Stack>
  );
}
